import { useGameStore } from "../state/store";
import type { LocalizedText } from "../types";
import { localize } from "./localize";

/**
 * Returns a resolver that turns bilingual content text into a string for the
 * current language. Reading the language from the store means a runtime language
 * switch re-renders content without reloading it.
 */
export function useLocalize(): (text: LocalizedText) => string {
  const language = useGameStore((state) => state.settings.language);
  return (text) => localize(text, language);
}
